import React, { useImperativeHandle, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import boTheme from '@ecp/common/src/style/theme/bo';

const FormContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ labelSize, column }) => `repeat(${column}, ${labelSize} 1fr)`};
  border-top: 1px solid ${boTheme.color.table1};
  --form-column: ${({ column }) => column * 2};
`;

const Form = React.forwardRef(({ labelSize, column, children }, ref) => {
  const formRef = useRef(null);

  useImperativeHandle(ref, () => formRef.current);

  return (
    <FormContainer labelSize={labelSize} column={column} ref={formRef}>
      {children}
    </FormContainer>
  );
});

Form.displayName = 'Form';

Form.propTypes = {
  labelSize: PropTypes.string,
  column: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
};

Form.defaultProps = {
  labelSize: '170px',
  column: 2,
};

export default Form;
